import styled from 'styled-components'
import { device } from 'src/theme/theme'

export const Container = styled.div`
  overflow-x: hidden;
  flex: 1 1 0;
  display: flex;
`

export const Content = styled.div`
  flex: 1 1 0;
  min-height: 100vh;
  overflow-x: hidden;
  padding: 1rem 1rem;

  @media ${device.tablet} {
    //z-index: 1;
    border-left: 1px solid ${p => p.theme.colors.palette.neutral400};
  }

  .player-wrapper {
    position: relative;
    padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */
    margin-bottom: ${p => p.theme.spacing.medium};
  }

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }

  .react-tabs__tab-list {
    display: flex;
    list-style: none;
    margin: 0 auto;
  }

  .react-tabs__tab {
    cursor: pointer;
    margin-bottom: 1rem;
    padding: 0.5rem 1rem;
    border: 0 solid;
    bottom: 0;
    position: static;
    border-bottom: 3px solid transparent;
  }

  .react-tabs__tab-list {
    border-bottom: none;

    padding-left: ${p => p.theme.spacing.huge};

    @media (max-width: 768px) {
      padding-left: 0;
    }
  }

  .react-tabs__tab--selected {
    border-color: ${({ theme }) => theme.colors.secondaryBackgroundColor} !important;
  }

  .react-tabs__tab-panel {
    margin: 0 auto;
    padding: 0 0 1rem;
    transition: all 0.2s ease 0s;
    position: relative;
    width: 100%;
    padding-left: ${p => p.theme.spacing.huge};

    @media (max-width: 768px) {
      padding-left: 0;
    }
  }

  .react-tabs__tab-panel--selected {
    animation: fade-and-slide-in 250ms ease-out;
  }

  @keyframes fade-and-slide-in {
    0% {
      right: -100%;
    }
    100% {
      right: 0;
    }
  }

  .box-teacher-container {
    display: flex;
    flex-direction: column;
    margin: 1rem 0;
    background: ${({ theme }) => theme.colors.palette.neutral200};
  }
`

export const TabsArea = styled.div`
  display: flex;
  overflow: hidden;
  margin: 0 auto;

  h4 {
    ${({ theme }) => theme.size.md}
  }
`

export const ClassroomDesc = styled.div`
  padding: 0;
  .title-area {
    display: flex;
    flex-direction: column-reverse;
    gap: 1rem;

    justify-content: space-between;
    margin: 1rem 0;

    @media ${device.tablet} {
      flex-direction: row;
    }

    button {
      align-self: flex-end;
      @media ${device.tablet} {
        align-self: flex-start;
      }
    }
  }

  a {
    color: ${props => props.theme.colors.secondaryBackgroundColor} !important;
    text-decoration: underline;
    display: inline-block;
    margin-bottom: 10px;
  }

  h2 {
    @media ${device.tablet} {
      max-width: 80%;
    }
  }
`

export const ExercisesContainer = styled.div`
  & + & {
    margin-top: 2rem;
  }
  h2 {
    margin: 1rem 0;
  }

  a {
    display: inline-block;
    margin-top: 1rem;
  }
`

export const ButtonsWrapper = styled.div`
  margin-bottom: 10px;
  display: flex;
  gap: 20px;
  justify-content: flex-start;

  @media (max-width: 1024px) {
    justify-content: flex-start;
    gap: 10px;
  }
`
